import { AgPolarChartOptions } from "ag-charts-enterprise";
import { AgCharts } from "ag-charts-react";
import { useTheme } from "next-themes";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import { IBaseFilterBrokerRank } from "./BrokerRankIndex";
import WeightedSliderReuseable from "./WeightedSliderReuseable";

export interface IsliderObjects {
  id: number;
  header: string;
  color: string;
  value: number;
  mapping: string;
}

function createSliderObjectsArr(dataFilters: IBaseFilterBrokerRank) {
  return [
    {
      id: 1,
      header: "Total DV01",
      color: "#43AA8B", //7CCFB8
      value: dataFilters.DVO1Percent,
      mapping: "DVO1Percent",
    },
    {
      id: 6,
      header: "Hit Rate",
      color: "#7E82DA", //7E82DA
      value: dataFilters.HitRatePercent,
      mapping: "HitRatePercent",
    },
    {
      id: 5,
      header: "Avg Spread (bps)",
      color: "#F77F00", // FBAF4B
      value: dataFilters.SpreadPercent,
      mapping: "SpreadPercent",
    },
    {
      id: 2,
      header: "Time to Quote Avg",
      color: "#8D99AE", //B0B8C5
      value: dataFilters.TimePercent,
      mapping: "TimePercent",
    },
  ];
}

const WeightedSliders = ({
  dataFilters,
  setDataFilters,
}: {
  dataFilters: IBaseFilterBrokerRank;
  setDataFilters: React.Dispatch<SetStateAction<IBaseFilterBrokerRank>>;
}) => {
  const { theme } = useTheme();

  const [sliderObjects, setSliderObjects] = useState<IsliderObjects[]>(
    createSliderObjectsArr(dataFilters),
  );

  useEffect(() => {
    // update all the sliders based on the base filter changes.
    setSliderObjects(createSliderObjectsArr(dataFilters));
  }, [dataFilters]);

  const colourFills = sliderObjects.map((obj) => obj.color);

  // DONUT CHART
  const options = useMemo<AgPolarChartOptions>(() => {
    return {
      theme: theme == "dark" ? "ag-default-dark" : "ag-default",
      data: sliderObjects,
      background: {
        visible: false,
      },
      width: 95,
      height: 95,
      legend: {
        enabled: false,
      },
      series: [
        {
          type: "donut",
          calloutLabelKey: "header",
          angleKey: "value",
          calloutLabel: {
            enabled: false,
          },
          fills: colourFills,
        },
      ],
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme, sliderObjects]);

  return (
    <div className="flex h-full w-full flex-col px-4">
      <div id="brokerSliderHeader" className="flex h-6 w-full justify-between">
        <div className="text-md flex w-full">
          <div className="flex h-full">
            <div className="relative top-3 flex h-2 w-[100px]">
              Weighted % :
            </div>
          </div>
        </div>
        <div className="flex w-full justify-end">
          <div className="flex">
            <div className="relative bottom-5 flex">
              <AgCharts
                //   ref={chartRef}
                className={`m-0 flex h-full w-full p-0`}
                options={options}
              />
            </div>
          </div>
        </div>
      </div>
      <div id="multiSliderContainer" className="pl-2 pt-6 ">
        {sliderObjects.map((sliderObj, index) => (
          <WeightedSliderReuseable
            sliderObj={sliderObj}
            dataFilters={dataFilters}
            setDataFilters={setDataFilters}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default WeightedSliders;
